import { CoursePreviewDto } from './course.dto';

export class CoursePreview {
    id: string;
    name: string;

    constructor(data: CoursePreviewDto) {
        this.id = data.id;
        this.name = data.name;
    }
}
